import { render } from "./ReportPaymentMethod.vue?vue&type=template&id=150563d5"
import script from "./ReportPaymentMethod.vue?vue&type=script&lang=js"
export * from "./ReportPaymentMethod.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__